import { render } from "./DeviceUptimeChart.vue?vue&type=template&id=81faa8d4"
import script from "./DeviceUptimeChart.vue?vue&type=script&lang=js"
export * from "./DeviceUptimeChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__